import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { formatTalkDateTime } from '../../../helpers/talkDate';
import { talkSpeakers } from '../../../helpers/talkSpeakers';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import CardImage from '../Views/CardImage';
import { vocabTitle } from '../../../helpers/content';

const FlexTalkCard = memo(({ item, compact, hideLink, gridLayout }) => {
  const dateLabel = formatTalkDateTime(item.talk_start, item.timezone);
  // A listing delivers catalog metadata, which carries the vocabulary titles
  // as talk_type_label/talk_stage_label, not the type_of_talk field itself.
  const typeLabel = [
    item.talk_type_label || vocabTitle(item.type_of_talk),
    item.talk_stage_label || vocabTitle(item.talk_stage),
  ]
    .filter(Boolean)
    .join(' · ');
  // Names only: the card itself is the link.
  const speakers = talkSpeakers(item)
    .map((speaker) => speaker.name)
    .join(', ');

  const titleBlock = (
    <>
      {typeLabel && <h6 className="cards__subtitle">{typeLabel}</h6>}
      <h4 className="cards__title">{item.title ? item.title : item.id}</h4>
    </>
  );

  return (
    <div
      className={`cards__item ${gridLayout ? 'cards__item--grid' : 'cards__item--fullwidth'}`}
    >
      {!compact && (
        <CardImage
          item={item}
          fallback={'/talk_default_image.svg'}
          gridLayout={gridLayout}
          href={hideLink ? undefined : item['@id']}
        />
      )}
      <div className="cards__content">
        {hideLink ? (
          titleBlock
        ) : (
          <UniversalLink href={item['@id']}>{titleBlock}</UniversalLink>
        )}
        {dateLabel && <p className="cards__info">{dateLabel}</p>}
        {speakers && <p className="cards__info">{speakers}</p>}
      </div>
    </div>
  );
});

FlexTalkCard.displayName = 'FlexTalkCard';

FlexTalkCard.propTypes = {
  item: PropTypes.shape({
    '@id': PropTypes.string.isRequired,
    title: PropTypes.string,
    id: PropTypes.string,
    talk_type_label: PropTypes.string,
    talk_stage_label: PropTypes.string,
    talk_stage: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({ title: PropTypes.string }),
    ]),
    type_of_talk: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({ title: PropTypes.string }),
    ]),
    talk_start: PropTypes.string,
    speaker: PropTypes.string,
    related_speakers: PropTypes.array,
    image_caption: PropTypes.string,
    image_scales: PropTypes.object,
  }).isRequired,
  compact: PropTypes.bool,
  hideLink: PropTypes.bool,
  gridLayout: PropTypes.bool,
};

export default FlexTalkCard;
